"use client";

import React, { type ReactElement } from "react";
import { createRoot } from "react-dom/client";

import { ReactAnimation } from "@rootreeweb/animations";
import { extractSource } from "@rootreeweb/js-lib";

import holidayCampaignFallback from "@/assets/animations/holiday_campaign.png";
import holidayCampaign from "@/assets/animations/holiday_campaign.riv";

/**
 * Mounts the Warmest Wishes animation.
 *
 * @param container The container to mount the animation to.
 */
export function init(container: HTMLDivElement): void {
	const root = createRoot(container);
	root.render(<WarmestWishesAnimation />);
}

/** @returns The component. */
export function WarmestWishesAnimation(): ReactElement {
	return (
		<div className="hl:grid hl:max-h-[850px]">
			<div className="hl:self-center hl:bg-contain hl:bg-top hl:[background:url('../assets/holiday-cards/purple-shape.svg')_no-repeat_top_center] hl:[grid-area:1/1]"></div>
			<div className="hl:h-(--offset) hl:max-h-[37%] hl:self-end hl:bg-top hl:[--offset:clamp(125px,27.5vh,300px)] hl:[background:#fff_url('../assets/holiday-cards/floor.png')] hl:[grid-area:1/1] hl:lg:max-h-[32%]"></div>

			<div className="hl:mb-4 hl:flex hl:max-h-[750px] hl:w-[clamp(0px,100vw,1153px)] hl:justify-center hl:place-self-center hl:bg-top hl:[grid-area:1/1]">
				<ReactAnimation
					fallbackImageSrc={extractSource(holidayCampaignFallback)}
					fileName={extractSource(holidayCampaign)}
					height={600}
					options={'{"stateMachines":"State Machine 1"}'}
					width={1200}
				/>
				{/*<?php echo do_shortcode( sprintf( '[rt-rive-animation %s]', "name='holiday_campaign' width='1200' height='600' fallback-extension='png' options='{\"stateMachines\":\"State Machine 1\"}' asset-folder='" . RT_HOLIDAY_DIR_URL . "assets/animations/'" ) ); ?>*/}
			</div>
		</div>
	);
}
